// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@wix/yoshi-style-dependencies/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wi0FqO{border:1px solid var(--wsr-color-D60, #dfe5eb);border-radius:6px}.oVJCA4{box-sizing:border-box}.oVJCA4 .Kuf3e_{display:flex;align-items:center}.oVJCA4 .Kuf3e_ svg{margin-right:5px}.oVJCA4 .QFNtJ7{color:var(--wsr-color-D30, #595d70)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Wi0FqO`,
	"root": `oVJCA4`,
	"label-installed": `Kuf3e_`,
	"labelInstalled": `Kuf3e_`,
	"label-price": `QFNtJ7`,
	"labelPrice": `QFNtJ7`
};
export default ___CSS_LOADER_EXPORT___;
